// Lỗi "chế độ non-interactive mà token chết/thiếu" — KHÔNG mở device flow (force update, D5).
//
// VÌ SAO CÓ FILE NÀY: updater AvatarCodi gọi `sync --all --reinstall --non-interactive` ở nền.
// Trước đây token chết ⇒ `ensureValidTokenOrLogin` chạy `runLogin` ⇒ mở trình duyệt và poll
// tới 1800s — tiến trình ngầm treo, user bị đá sang browser không rõ lý do.
//
// Mã thoát RIÊNG (3), không gộp vào 1: phía gọi phải phân biệt "cần đăng nhập" (hiện toast mời
// login, thử lại vòng sau) với "sync hỏng" (lỗi thật) mà không parse text. CLI hiện chỉ dùng
// 0 / 1 / 130 ⇒ 3 không đụng nghĩa nào đang có.
//
// Tách khỏi `non-interactive-abort-error.ts`: lớp đó luôn trả mã 1 và payload có `aborted_by`
// — cờ người gọi chọn; ở đây không có cờ nào để đổi, chỉ có hành động "đăng nhập".
// Nhưng VẪN nằm trong `isNonInteractiveFatalError` (file kia) để mọi guard rethrow hiện có
// cho nó nổi lên `index.ts` thay vì nuốt thành exit 1.
import { JSON_SCHEMA_VERSION } from "./machine-readable-json-output-contract.js";

export const LOGIN_REQUIRED_EXIT_CODE = 3;
export const LOGIN_REQUIRED_REASON = "login_required";

export class LoginRequiredError extends Error {
  readonly command: string;
  /** Nguyên nhân từ tầng token (chưa login / refresh_token revoked …) — không chứa token. */
  readonly detail: string;

  constructor(params: { command: string; detail: string }) {
    super(
      `Cần đăng nhập lại (chế độ non-interactive không mở device flow): ${params.detail}. ` +
        "Chạy `avatar login` rồi thử lại.",
    );
    this.name = "LoginRequiredError";
    this.command = params.command;
    this.detail = params.detail;
  }
}

/** Nhận diện qua `name` — `instanceof` gãy khi module bị nạp 2 lần (ESM + bundle). */
export function isLoginRequiredError(err: unknown): err is LoginRequiredError {
  return err instanceof Error && err.name === "LoginRequiredError";
}

/** In JSON 1 dòng ra stderr (luật 4 hợp đồng máy-đọc) rồi trả mã thoát — caller tự `exit`. */
export function reportLoginRequired(err: LoginRequiredError): number {
  process.stderr.write(
    `${JSON.stringify({
      schema_version: JSON_SCHEMA_VERSION,
      command: err.command,
      reason: LOGIN_REQUIRED_REASON,
      detail: err.detail,
      hint: "Chạy `avatar login` rồi thử lại.",
    })}\n`,
  );
  return LOGIN_REQUIRED_EXIT_CODE;
}
